var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('MenuTeacher'),_c('div',{staticClass:"teacher-container"},[_c('a-layout',[_c('a-layout-sider',[_c('SideMenuTeacher')],1),_c('a-layout-content',[_c('a-card',{attrs:{"bordered":false}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }